import { AppRouteType } from 'layouts/helper';
import routesMap from 'layouts/routesMap';
import { memoize } from 'lodash';
import { lazy } from 'react';

const LoginPage = lazy(() => import('pages/DangNhap/LoginPage'));
const SingupPage = lazy(() => import('pages/DangNhap/SignupPage'));
const ForgetpassPage = lazy(() => import('pages/DangNhap/ForgetpassPage'));

const routes: AppRouteType[] = [
  {
    path: routesMap.LOGIN,
    component: LoginPage,
  },
  {
    path: routesMap.SIGNUP,
    component: SingupPage,
  },
  {
    path: routesMap.FORGET_PASSWORD,
    component: ForgetpassPage,
  },
];

const getRoutePublic = memoize(() => {
  return routes;
});

export default getRoutePublic;
